/*
    name: 公共接口请求
*/
import request from './axiosFun';
import apiHttp from './apiHttp';

var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

// 助贷查询机构列表（全部）
export function getInstitutionInfoList() {
  return apiHttp({
    url: url + '/finance/institutionInfo/getInstitutionInfoList',
    method: 'post',
    data
  });
}

//  获取榆林市全部牧场数据
export function findLatitudeAndLongitudeGroup() {
  return apiHttp({
    url: url + '/project-server/latitudeAndLongitude/findLatitudeAndLongitudeGroup',
    method: 'GET'
  });
}

// 见犊补母字典值（新）层级多 获取值
export function findDictAppInfo(data) {
  return apiHttp({
    url: url + '/base-server/appAreaInfo/findDictAppInfo',
    method: 'post',
    data
  });
}

// 智慧畜牧字典值（新）直接获取值
export function findSimpleDictInfo(data) {
  return apiHttp({
    url: url + '/base-server/appAreaInfo/findSimpleDictInfo',
    method: 'post',
    data
  });
}

// 获取地图(2024-11-05)靖边演示地图接口
export function screenFarmForMap(data) {
  return apiHttp({
    url: url + 'project-server/jingbianMap/screenFarmForMap',
    method: 'post',
    data
  });
}

// 天眼查
export function fuzzySearch(query) {
  return request({
    url: url + '/pasture/tianyancha/fuzzySearch',
    method: 'post',
    data: query
  });
}

// 身份证验证-图片信息
export function ocrInfo(query) {
  return request({
    url: url + '/base-server/aliOperate/ocrInfo',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/public.js